import { FC } from "react";
import { MenuItem, Select, SxProps } from "@mui/material";
import * as React from "react";
import { SelectChangeEvent } from "@mui/material";
import { useSxMergeStrict } from "shared-ts-mui";

export interface UnitSelectProps {
  selected: string;
  options: Array<string>;
  onChange: (value: string) => void;
  tabbable?: boolean;
}

export const UnitSelect: FC<UnitSelectProps> = (props) => {
  const handleChange = (event: SelectChangeEvent, child: React.ReactNode) => {
    props.onChange(event.target.value);
  };

  return (
    <Select
      value={props.selected}
      size={"small"}
      variant={"standard"}
      sx={{
        "&::before": {
          borderBottom: "unset",
        },
      }}
      onChange={handleChange}
      slotProps={{
        input: { tabIndex: props.tabbable ? 0 : -1 },
      }}
    >
      {props.options.map((option) => {
        return (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        );
      })}
    </Select>
  );
};
